var _circle, _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSuccess = function SvgSuccess(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    fill: "none",
    viewBox: "0 0 29 29",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.15,
    cy: 14.976,
    r: 14,
    fill: "#e9fff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008148",
    d: "M11.88 19.757a.727.727 0 0 0 1.012 0l8.039-8.039a.726.726 0 0 0 0-1.011l-.984-.985a.693.693 0 0 0-.985 0L12.4 16.285l-3.09-3.063a.693.693 0 0 0-.984 0l-.985.985a.726.726 0 0 0 0 1.011l4.54 4.54Z"
  })));
};
export { SvgSuccess as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTQuMTQ5OCIgY3k9IjE0Ljk3NjEiIHI9IjE0IiBmaWxsPSIjZTlmZmYxIi8+CjxwYXRoIGQ9Ik0xMS44ODAyIDE5Ljc1NzRDMTIuMTUzNyAyMC4wMzA4IDEyLjYxODUgMjAuMDMwOCAxMi44OTIgMTkuNzU3NEwyMC45MzEgMTEuNzE4M0MyMS4yMDQ1IDExLjQ0NDkgMjEuMjA0NSAxMC45OCAyMC45MzEgMTAuNzA2NkwxOS45NDY3IDkuNzIyMjNDMTkuNjczMiA5LjQ0ODc5IDE5LjIzNTcgOS40NDg3OSAxOC45NjIzIDkuNzIyMjNMMTIuMzk5OCAxNi4yODQ3TDkuMzA5OTQgMTMuMjIyMkM5LjAzNjUgMTIuOTQ4OCA4LjU5OSAxMi45NDg4IDguMzI1NTYgMTMuMjIyMkw3LjM0MTE5IDE0LjIwNjZDNy4wNjc3NSAxNC40OCA3LjA2Nzc1IDE0Ljk0NDkgNy4zNDExOSAxNS4yMTgzTDExLjg4MDIgMTkuNzU3NFoiIGZpbGw9IiMwMDgxNDgiLz4KPC9zdmc+Cg==";